// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import "./questiondashborad.css";

// const TableComponent = ({
//   headers,
//   data,
//   searchPlaceholder,
//   dataClient,
//   setPagePath,
// }) => {
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const [filterRunTime, setFilterRunTime] = useState("");
//   const columnDropdownRef = useRef(null);
//   const [selectedRows, setSelectedRows] = useState([]);

//   useEffect(() => {
//     setVisibleColumns(headers.slice(0, 5));
//   }, [headers]);

//   const handleColumnSelection = (column) => {
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter((col) => col !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleFilterRunTimeChange = (e) => {
//     setFilterRunTime(e.target.value);
//   };

//   const handleApplyFilter = () => {
//     setAverageRunTime(filterRunTime);
//     setIsFilterVisible(false); // Close the modal
//     setCurrentPage(1); // Reset to the first page on filter
//   };

//   // const filteredData = data.filter((row) => {
//   //     const matchesSearchQuery = row[0]
//   //         .toLowerCase()
//   //         .includes(searchQuery.toLowerCase());
//   //     const matchesAverageRunTime =
//   //         averageRunTime === "" || row[2] === averageRunTime;
//   //     return matchesSearchQuery && matchesAverageRunTime;
//   // });

//   // const filteredData = data.filter((row) => {
//   //     const matchesSearchQuery = row[0] && String(row[0]).toLowerCase().includes(searchQuery.toLowerCase());
//   //     const matchesAverageRunTime = averageRunTime === "" || row[2] === averageRunTime;
//   //     return matchesSearchQuery && matchesAverageRunTime;
//   // });

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;
//     return matchesSearchQuery && matchesAverageRunTime;
//   });

//   const handleCancel = () => {
//     window.location.reload(); // This will refresh the page
//   };
//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }
//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handleExport = (type) => {
//     const exportData = sortedData.map((row) =>
//       visibleColumns.map((column) => row[headers.indexOf(column)])
//     );

//     const fileName = prompt("Enter the file name:");

//     if (!fileName) {
//       return;
//     }

//     if (type === "excel" || type === "csv") {
//       const worksheet = XLSX.utils.aoa_to_sheet([
//         visibleColumns,
//         ...exportData,
//       ]);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//       const fileExtension = type === "csv" ? "csv" : "xlsx";
//       const mimeType =
//         type === "csv"
//           ? "text/csv"
//           : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

//       const file = XLSX.write(workbook, {
//         bookType: fileExtension,
//         type: "array",
//       });
//       const blob = new Blob([file], { type: mimeType });
//       FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
//     } else if (type === "pdf") {
//       const doc = new jsPDF();
//       doc.autoTable({
//         head: [visibleColumns],
//         body: exportData,
//       });

//       doc.save(`${fileName}.pdf`);
//     }
//   };

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1); // Reset to the first page
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {i}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "1.5%",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "82vw",
//           }}
//         >
//           {/* <div style={{ display: "flex", alignItems: "center" }}>
//                         <input
//                             type="text"
//                             placeholder={searchPlaceholder}
//                             name="search"
//                             className="input-top-tc"
//                             onChange={handleSearch}
//                         />
//                         <img src={searchicon} className="search-icon-tc" alt="search" />
//                     </div> */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div
//         // className="row-tc"
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           // className="col-cs2-tc"
//           style={{
//             display: "flex",
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           // onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img
//             src={Filter}
//             style={{ height: "24px", width: "24px" }}
//             alt="filter"
//           />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         {/* <div
//                     style={{
//                         display: "flex",
//                         alignItems: "center",
//                         marginLeft: "20px",
//                         cursor: "pointer",
//                     }}
//                     onClick={() => setIsModalVisible(true)}
//                 >
//                     <img
//                         src={FileExport}
//                         style={{ height: "25px", width: "25px" }}
//                         alt="export"
//                         onClick={() => setIsModalVisible(true)}
//                     />
//                     <span style={{ marginLeft: "10px", color: "#2F2E40" }}>
//                         Export
//                     </span>
//                 </div> */}
//         <div
//           // className="col-tc"
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={(e) => {
//             // Only toggle if the actual icon or text is clicked, not inside the dropdown
//             if (!columnDropdownRef.current?.contains(e.target)) {
//               setIsColumnDivVisible(!isColumnDivVisible);
//             }
//           }}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc" ref={columnDropdownRef}>
//                 {/* Always show Set Name first, checked and disabled */}
//                 <div>
//                   <input
//                     type="checkbox"
//                     id="column-SetName"
//                     name="columnSelection"
//                     value="Set Name"
//                     className="square-checkbox-tc"
//                     checked={true}
//                     readOnly
//                     disabled
//                   />
//                   <label htmlFor="column-SetName">Set Name</label>
//                 </div>
//                 {/* Show the rest of the columns */}
//                 {headers
//                   .filter((column) => column !== "Set Name")
//                   .map((column, index) => (
//                     <div
//                       key={index}
//                       onClick={() => handleColumnSelection(column)}
//                     >
//                       <input
//                         type="checkbox"
//                         id={`column-${index}`}
//                         name="columnSelection"
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         readOnly
//                       />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))}
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//       <table className="table-tc" style={{ width: "100%" }}>
//         <thead>
//           <tr>
//             {visibleColumns.map((heading, index) => (
//               <td
//                 className="Heading-tc"
//                 key={index}
//                 style={{ textAlign: "right", cursor: "pointer" }}
//               >
//                 <span
//                   style={{
//                     display: "flex",
//                     alignItems: "left",
//                     justifyContent: "left",
//                     color: "#424242",
//                   }}
//                 >
//                   {heading}
//                   <img
//                     onClick={() => handleSort(heading)}
//                     src={updown}
//                     style={{
//                       height: "20px",
//                       width: "20px",
//                       marginLeft: "5px",
//                     }}
//                     alt="sort"
//                   />
//                 </span>
//               </td>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {paginatedData.map((row, rowIndex) => (
//             <tr
//               key={rowIndex}
//               className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//             >
//               {visibleColumns.map((column, cellIndex) => (
//                 <td
//                   key={cellIndex}
//                   style={{ textAlign: "left", color: "#6A6A6A" }}
//                 >
//                   {headers.indexOf(column) === 0 ? (
//                     // This is the updated part for "Set Name"
//                     <Link
//                       style={{
//                         display: "inline-block",
//                         maxWidth: "200px",
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                         color: "#337ab7",
//                         verticalAlign: "middle", // Helps align with other cells
//                       }}
//                       to={`/ques_dashboard?setId=${encodeURIComponent(row[8])}`}
//                       // The 'title' attribute creates the hover tooltip
//                       title={row[headers.indexOf(column)]}
//                       state={{
//                         setName: row[headers.indexOf("Set Name")],
//                         course: row[headers.indexOf("Course(s)")],
//                         subject: row[headers.indexOf("Subject(s)")],
//                         createdBy: row[headers.indexOf("Created By")],
//                         createdOn: row[headers.indexOf("Created On")],
//                         status: row[headers.indexOf("Status")],
//                         setId: row[8],
//                       }}
//                     >
//                       {row[headers.indexOf(column)]}
//                     </Link>
//                   ) : (
//                     // This part for other columns remains the same
//                     row[headers.indexOf(column)]
//                   )}
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       <div className="pagination-tc">
//         <button
//           onClick={() => handlePageChange(1)}
//           disabled={currentPage === 1}
//           className="extreme-left-tc-pagination"
//         >
//           <img src={leftArrow} alt="" />
//         </button>
//         <button
//           onClick={() => handlePageChange(currentPage - 1)}
//           disabled={currentPage === 1}
//           className="lefttc-pagination"
//         >
//           {"<"}
//         </button>
//         {renderPagination()}
//         <button
//           onClick={() => handlePageChange(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           className="righttc-pagination"
//         >
//           {">"}
//         </button>
//         <button
//           onClick={() => handlePageChange(totalPages)}
//           disabled={currentPage === totalPages}
//           className="extreme-right-tc-pagination"
//         >
//           <img src={rightArrow} alt="" />
//         </button>
//       </div>

//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button
//               className="repman-cross-btn"
//               style={{
//                 position: "absolute",
//                 left: "-29px",
//                 height: "40px",
//                 width: "30px",
//                 color: "white",
//                 border: "none",
//                 fontSize: "20px",
//                 fontWeight: "700",
//                 borderRadius: "5px 0px 0px 5px",
//               }}
//               onClick={() => {
//                 setIsFilterVisible(false);
//               }}
//             >
//               <p>X</p>
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div style={{ display: "flex", justifyContent: "end" }}>
//               <button
//                 style={{
//                   width: "30%",
//                   height: "32px",
//                   borderRadius: "5px",
//                   border: "2px solid #2F2E40",
//                   fontSize: "16px",
//                   fontWeight: "700",
//                   backgroundColor: "white",
//                   marginRight: "8px",
//                   marginTop: "10px",
//                 }}
//                 onClick={handleApplyFilter}
//               >
//                 APPLY
//               </button>
//             </div>
//             <input
//               type="text"
//               placeholder="Enter Average Run Time"
//               value={filterRunTime}
//               onChange={handleFilterRunTimeChange}
//             />
//           </div>
//         </div>
//       )}

//       {isModalVisible && (
//         <div>
//           <div className="arrow-up-tc-QB"></div>
//           <div className="arrow-up-tc-QB-model">
//             <div className="modal-content-tc">
//               <h3>Select Export File Type</h3>
//               <button
//                 onClick={() => [
//                   handleExport("excel"),
//                   setIsModalVisible(false),
//                 ]}
//               >
//                 Excel
//               </button>
//               <button
//                 onClick={() => [handleExport("csv"), setIsModalVisible(false)]}
//               >
//                 CSV
//               </button>
//               <button
//                 onClick={() => [handleExport("pdf"), setIsModalVisible(false)]}
//               >
//                 PDF
//               </button>
//               <button onClick={() => setIsModalVisible(false)}>Cancel</button>
//             </div>
//           </div>
//           {/* <div className="modal-tc-QB">
//                         <div className="modal-content-tc">
//                             <h3>Select Export File Type</h3>
//                             <button
//                                 onClick={() => [handleExport("excel"), setIsModalVisible(false)]}
//                             >
//                                 Excel
//                             </button>
//                             <button
//                                 onClick={() => [handleExport("csv"), setIsModalVisible(false)]}
//                             >
//                                 CSV
//                             </button>
//                             <button
//                                 onClick={() => [handleExport("pdf"), setIsModalVisible(false)]}
//                             >
//                                 PDF
//                             </button>
//                             <button onClick={() => setIsModalVisible(false)}>Cancel</button>
//                         </div>
//                     </div> */}
//         </div>
//       )}
//     </div>
//   );
// };

// const QuestionDashboard = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const [selectedSetId, setSelectedSetId] = useState(null);
//   const navigate = useNavigate();
//   const accessToken = localStorage.getItem("other");

//   useEffect(() => {
//     fetchDashboardData();
//   }, []);

//   const headers = [
//     "Set Name",
//     "No. of Questions",
//     "Course(s)",
//     "Subject(s)",
//     "Created By",
//     "Created On",
//     "Modified On",
//     "Status",
//   ];

//   const fetchDashboardData = async () => {
//     try {
//       const response = await fetch(
//         ` ${FULL_API_BASE_URL}/get-parse-ques-set-dashboard/`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Failed to fetch dashboard data");
//       }

//       const data = await response.json();

//       const formatDate = (dateString) => {
//         const months = [
//           "Jan",
//           "Feb",
//           "Mar",
//           "Apr",
//           "May",
//           "Jun",
//           "Jul",
//           "Aug",
//           "Sep",
//           "Oct",
//           "Nov",
//           "Dec",
//         ];
//         const date = new Date(dateString);
//         const day = String(date.getDate()).padStart(2, "0");
//         const month = months[date.getMonth()];
//         const year = date.getFullYear();
//         return `${day} ${month} ${year}`;
//       };

//       const transformedData = data?.data?.map((set) => [
//         set.set_name,
//         set.no_of_questions,
//         set.courses,
//         set.subjects,
//         set.created_by,
//         formatDate(set.created_on),
//         formatDate(set.modified_on),
//         set.status,
//         set.set_id,
//       ]);
//       setReportDashboardData(transformedData);
//     } catch (error) {
//       console.error("Error fetching dashboard data:", error);
//     }
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "20px",
//         marginBottom: "40px",
//       }}
//     >
//       <div
//         className=""
//         style={{ position: "sticky", top: "0", paddingLeft: "15px" }}
//       >
//         <div className="create-role-container-ques-dashboards">
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Question Set Dashboard
//           </p>
//           <div
//             style={{
//               display: "flex",
//               justifyItems: "center",
//               alignItems: "center",
//             }}
//           >
//             <button
//               className="create-test-section-btn"
//               onClick={() => navigate("/parse_bulk_questions")}
//               style={{
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//               }}
//             >
//               <span className="plus-icon-create">+</span>PARSE
//             </button>
//             {/* <button
//                             className="create-test-section-btn"
//                             onClick={() => navigate("/parse_bulk_questions")}
//                             style={{ marginRight: "18px", backgroundColor: "#2F2E40", color: "white", cursor: "not-allowed" }}
//                             disabled
//                         >
//                             <span className="plus-icon-create" style={{ color: "white" }}>+</span>CREATE
//                         </button> */}
//           </div>
//         </div>
//         <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//           View, create, or filter Questions. Export a list of question or search
//           for a question. When searching, enter at least two characters in the
//           search field.
//         </p>
//         <div>
//           <TableComponent
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Questions..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default QuestionDashboard;

// FIXED THE ISSUE COLUMN SELECTION SELECT AND DESELECT ALL FUNCTIONALITY

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import "./questiondashborad.css";

const TableComponent = ({
  headers,
  data,
  searchPlaceholder,
  dataClient,
  setPagePath,
}) => {
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [averageRunTime, setAverageRunTime] = useState("");
  const [filterRunTime, setFilterRunTime] = useState("");
  const columnDropdownRef = useRef(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const initializedRef = useRef(false);

  // Replace the existing useEffect with this:
  useEffect(() => {
    if (!initializedRef.current && headers.length > 0) {
      setVisibleColumns(headers.filter((_, index) => index < 5));
      initializedRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleColumnSelection = (column) => {
    if (visibleColumns.includes(column)) {
      setVisibleColumns(visibleColumns.filter((col) => col !== column));
    } else {
      setVisibleColumns([...visibleColumns, column]);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleFilterRunTimeChange = (e) => {
    setFilterRunTime(e.target.value);
  };

  const handleApplyFilter = () => {
    setAverageRunTime(filterRunTime);
    setIsFilterVisible(false);
    setCurrentPage(1);
  };

  const filteredData = data.filter((row) => {
    const matchesSearchQuery = row.some(
      (cell) =>
        cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
    );
    const matchesAverageRunTime =
      averageRunTime === "" || row[2] === averageRunTime;
    return matchesSearchQuery && matchesAverageRunTime;
  });

  const handleCancel = () => {
    window.location.reload();
  };

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig.key !== null) {
      const colIndex = headers.indexOf(sortConfig.key);
      sortableData.sort((a, b) => {
        if (a[colIndex] < b[colIndex]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[colIndex] > b[colIndex]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, headers]);

  const handleExport = (type) => {
    const exportData = sortedData.map((row) =>
      visibleColumns.map((column) => row[headers.indexOf(column)])
    );

    const fileName = prompt("Enter the file name:");

    if (!fileName) {
      return;
    }

    if (type === "excel" || type === "csv") {
      const worksheet = XLSX.utils.aoa_to_sheet([
        visibleColumns,
        ...exportData,
      ]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const fileExtension = type === "csv" ? "csv" : "xlsx";
      const mimeType =
        type === "csv"
          ? "text/csv"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      const file = XLSX.write(workbook, {
        bookType: fileExtension,
        type: "array",
      });
      const blob = new Blob([file], { type: mimeType });
      FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
    } else if (type === "pdf") {
      const doc = new jsPDF();
      doc.autoTable({
        head: [visibleColumns],
        body: exportData,
      });

      doc.save(`${fileName}.pdf`);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            style={{ borderRadius: "5px" }}
            className={i === currentPage ? "active" : ""}
          >
            {i}
          </button>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button
              key={i}
              style={{ borderRadius: "5px" }}
              onClick={() => handlePageChange(i)}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots2">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
      }
    }
    return pages;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnDropdownRef.current &&
        !columnDropdownRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1.5%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "82vw",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #6A6A6A",
              overflow: "hidden",
            }}
          >
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              className="search-input-ques-dash"
              onChange={handleSearch}
            />
            <div
              style={{
                width: "1px",
                height: "24px",
                backgroundColor: "#2F2E40",
                margin: "0 4px",
              }}
            ></div>
            <img
              src={searchicon}
              alt="search"
              className="search-icon-ques-dash"
            />
          </div>
          <div
            style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
          >
            Displaying{" "}
            {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
            {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
            {sortedData.length} records |
            {["10", "25", "50", "100", "500"].map((size) => (
              <span
                key={size}
                onClick={() => handlePageSizeChange(Number(size))}
                style={{
                  cursor: "pointer",
                  margin: "0 5px",
                  textDecoration:
                    size === pageSize.toString() ? "none" : "underline",
                  color: size === pageSize.toString() ? "black" : "#337AB7",
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        <div
          style={{
            display: "flex",
            backgroundColor: "#FFBD20",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: "8px",
            width: "90px",
          }}
        >
          <img
            src={Filter}
            style={{ height: "24px", width: "24px" }}
            alt="filter"
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>
        <div
          style={{
            marginLeft: "auto",
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
        >
          <img
            src={columnaddition}
            style={{ height: "34px", width: "32px" }}
            alt="column addition"
          />
          <span
            style={{
              marginLeft: "4px",
              color: "#2F2E40",
              marginRight: "14px",
              fontSize: "14px",
            }}
          >
            Column Selection
          </span>
          {isColumnDivVisible && (
            <div ref={columnDropdownRef}>
              <div className="arrow-up-tc"></div>
              <div className="popupColumn-tc">
                {headers.map((column, index) => (
                  <div
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleColumnSelection(column);
                    }}
                  >
                    <input
                      type="checkbox"
                      id={`column-${index}`}
                      name="columnSelection"
                      value={column}
                      className="square-checkbox-tc"
                      checked={visibleColumns.includes(column)}
                      readOnly
                    />
                    <label htmlFor={`column-${index}`}>{column}</label>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="table-container-scrollable">
        <table className="fixed-header-table" style={{ width: "100%" }}>
          <thead>
            <tr>
              {visibleColumns.map((heading, index) => (
                <td
                  className="Heading-tc"
                  key={index}
                  style={{ textAlign: "right", cursor: "pointer" }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "left",
                      justifyContent: "left",
                      color: "rgb(47, 46, 64)",
                      fontSize: "14px",
                    }}
                  >
                    {heading}
                    <img
                      onClick={() => handleSort(heading)}
                      src={updown}
                      style={{
                        height: "20px",
                        width: "20px",
                        marginLeft: "5px",
                      }}
                      alt="sort"
                    />
                  </span>
                </td>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
              >
                {visibleColumns.map((column, cellIndex) => (
                  <td
                    key={cellIndex}
                    style={{ textAlign: "left", color: "#6A6A6A" }}
                  >
                    {headers.indexOf(column) === 0 ? (
                      <Link
                        style={{
                          display: "inline-block",
                          maxWidth: "200px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color: "#337ab7",
                          verticalAlign: "middle",
                        }}
                        to={`/ques_dashboard?setId=${encodeURIComponent(
                          row[8]
                        )}`}
                        title={row[headers.indexOf(column)]}
                        state={{
                          setName: row[headers.indexOf("Set Name")],
                          course: row[headers.indexOf("Course(s)")],
                          subject: row[headers.indexOf("Subject(s)")],
                          createdBy: row[headers.indexOf("Created By")],
                          createdOn: row[headers.indexOf("Created On")],
                          status: row[headers.indexOf("Status")],
                          setId: row[8],
                        }}
                      >
                        {row[headers.indexOf(column)]}
                      </Link>
                    ) : (
                      row[headers.indexOf(column)]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination-tc">
        <button
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
          className="extreme-left-tc-pagination"
        >
          <img src={leftArrow} alt="" />
        </button>
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="lefttc-pagination"
        >
          {"<"}
        </button>
        {renderPagination()}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="righttc-pagination"
        >
          {">"}
        </button>
        <button
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
          className="extreme-right-tc-pagination"
        >
          <img src={rightArrow} alt="" />
        </button>
      </div>

      {isFilterVisible && (
        <div className="filter-sidebar-tc">
          <div className="filter-content-tc" style={{ position: "relative" }}>
            <button
              className="repman-cross-btn"
              style={{
                position: "absolute",
                left: "-29px",
                height: "40px",
                width: "30px",
                color: "white",
                border: "none",
                fontSize: "20px",
                fontWeight: "700",
                borderRadius: "5px 0px 0px 5px",
              }}
              onClick={() => {
                setIsFilterVisible(false);
              }}
            >
              <p>X</p>
            </button>
            <h3 className="AdvanceF-heading-tc"> Filter</h3>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button
                style={{
                  width: "30%",
                  height: "32px",
                  borderRadius: "5px",
                  border: "2px solid #2F2E40",
                  fontSize: "16px",
                  fontWeight: "700",
                  backgroundColor: "white",
                  marginRight: "8px",
                  marginTop: "10px",
                }}
                onClick={handleApplyFilter}
              >
                APPLY
              </button>
            </div>
            <input
              type="text"
              placeholder="Enter Average Run Time"
              value={filterRunTime}
              onChange={handleFilterRunTimeChange}
            />
          </div>
        </div>
      )}

      {isModalVisible && (
        <div>
          <div className="arrow-up-tc-QB"></div>
          <div className="arrow-up-tc-QB-model">
            <div className="modal-content-tc">
              <h3>Select Export File Type</h3>
              <button
                onClick={() => [
                  handleExport("excel"),
                  setIsModalVisible(false),
                ]}
              >
                Excel
              </button>
              <button
                onClick={() => [handleExport("csv"), setIsModalVisible(false)]}
              >
                CSV
              </button>
              <button
                onClick={() => [handleExport("pdf"), setIsModalVisible(false)]}
              >
                PDF
              </button>
              <button onClick={() => setIsModalVisible(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const QuestionDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  setNoTimeSet,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const [selectedSetId, setSelectedSetId] = useState(null);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("other");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const headers = [
    "Set Name",
    "No. of Questions",
    "Course(s)",
    "Subject(s)",
    "Created By",
    "Created On",
    "Modified On",
    "Status",
  ];

  // const fetchDashboardData = async () => {
  //   try {
  //     const response = await fetch(
  //       ` ${FULL_API_BASE_URL}/get-parse-ques-set-dashboard/`,
  //       {
  //         method: "GET",
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error("Failed to fetch dashboard data");
  //     }

  //     const data = await response.json();

  //     const formatDate = (dateString) => {
  //       const months = [
  //         "Jan",
  //         "Feb",
  //         "Mar",
  //         "Apr",
  //         "May",
  //         "Jun",
  //         "Jul",
  //         "Aug",
  //         "Sep",
  //         "Oct",
  //         "Nov",
  //         "Dec",
  //       ];
  //       const date = new Date(dateString);
  //       const day = String(date.getDate()).padStart(2, "0");
  //       const month = months[date.getMonth()];
  //       const year = date.getFullYear();
  //       return `${day} ${month} ${year}`;
  //     };

  //     const transformedData = data?.data?.map((set) => [
  //       set.set_name,
  //       set.no_of_questions,
  //       set.courses,
  //       set.subjects,
  //       set.created_by,
  //       formatDate(set.created_on),
  //       formatDate(set.modified_on),
  //       set.status,
  //       set.set_id,
  //     ]);
  //     setReportDashboardData(transformedData);
  //   } catch (error) {
  //     console.error("Error fetching dashboard data:", error);
  //   }
  // };

  const fetchDashboardData = async () => {
    setNoTimeSet(true);
    setIsLoading(true);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span style={{ marginLeft: "10px", marginTop: "3px" }}>
            Loading data, please wait...
          </span>
        </div>
      </div>
    );
    setActiveImg(false);

    const slowLoadingTimer = setTimeout(() => {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              This is taking longer than usual, please wait a moment...
            </span>
          </div>
        </div>
      );
    }, 5000);

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-parse-ques-set-dashboard/`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch dashboard data");
      }

      const data = await response.json();

      const formatDate = (dateString) => {
        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
      };

      const transformedData = data?.data?.map((set) => [
        set.set_name,
        set.no_of_questions,
        set.courses,
        set.subjects,
        set.created_by,
        formatDate(set.created_on),
        formatDate(set.modified_on),
        set.status,
        set.set_id,
      ]);

      setReportDashboardData(transformedData);

      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(false);
    } catch (error) {
      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              {error.message}
            </span>
          </div>
        </div>
      );
      console.error("Error fetching dashboard data:", error);
    }
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div
        className=""
        style={{ position: "sticky", top: "0", paddingLeft: "15px" }}
      >
        <div className="create-role-container-ques-dashboards">
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>
            Question Set Dashboard
          </p>
          <div
            style={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <button
              className="create-test-section-btn"
              onClick={() => navigate("/parse_bulk_questions")}
              style={{
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
              }}
            >
              <span className="plus-icon-create">+</span>PARSE
            </button>
          </div>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          View, create, or filter Questions. Export a list of question or search
          for a question. When searching, enter at least two characters in the
          search field.
        </p>
        <div>
          <TableComponent
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter Questions..."
            dataClient={dataClient}
            setPagePath={setPagePath}
          />
        </div>
      </div>
    </div>
  );
};

export default QuestionDashboard;
